/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} QeInputs */

const en_qe = /** @type {(inputs: QeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`qe-`)
};

const es_qe = /** @type {(inputs: QeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`qe-`)
};

const fr_qe = /** @type {(inputs: QeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`qe-`)
};

const de_qe = /** @type {(inputs: QeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`qe-`)
};

const ja_qe = /** @type {(inputs: QeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`qe-`)
};

const zh_qe = /** @type {(inputs: QeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`qe-`)
};

const ar_qe = /** @type {(inputs: QeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`qe-`)
};

const id_qe = /** @type {(inputs: QeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`qe-`)
};

const it_qe = /** @type {(inputs: QeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`qe-`)
};

const ru_qe = /** @type {(inputs: QeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`qe-`)
};

const pt_qe = /** @type {(inputs: QeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`qe-`)
};

const ko_qe = /** @type {(inputs: QeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`qe-`)
};

/**
* | output |
* | --- |
* | "qe-" |
*
* @param {QeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const qe = /** @type {((inputs?: QeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<QeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qe(inputs)
	if (locale === "es") return es_qe(inputs)
	if (locale === "fr") return fr_qe(inputs)
	if (locale === "de") return de_qe(inputs)
	if (locale === "ja") return ja_qe(inputs)
	if (locale === "zh") return zh_qe(inputs)
	if (locale === "ar") return ar_qe(inputs)
	if (locale === "id") return id_qe(inputs)
	if (locale === "it") return it_qe(inputs)
	if (locale === "ru") return ru_qe(inputs)
	if (locale === "pt") return pt_qe(inputs)
	return ko_qe(inputs)
});